// extracted by mini-css-extract-plugin
export var auto = "_32-1";
export var spinner = "_32-0";